import React from 'react'
import connect from 'libraries/front-end-core/decorators/connect'
import { requestHomePageArticles } from 'services/CurrentAwarenessService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import Dashboard from './Dashboard'

const ConnectedDashboard = connect(({ aol }) => ({
  homepageArticles: requestHomePageArticles(aol)
}))((props) => (
  <ResponseConsumer
    response={props.homepageArticles}
    skeleton='dashboard'
    content={() => <Dashboard {...props} />}
  />
))

export default ConnectedDashboard
